var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReduceIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2715_130766",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2715_130766)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.375 25.167V23.375H10V21.292H18.75V16.625H11.292C10.9587 16.625 10.66 16.5 10.396 16.25C10.132 16 10 15.6943 10 15.333V9.042C10 8.68067 10.125 8.375 10.375 8.125C10.625 7.875 10.9307 7.75 11.292 7.75H14.375V6H16.459V7.75H20.834V9.875H12.084V14.542H19.542C19.9033 14.542 20.209 14.66 20.459 14.896C20.709 15.132 20.834 15.4443 20.834 15.833V22.125C20.834 22.4863 20.7157 22.785 20.479 23.021C20.243 23.257 19.9307 23.375 19.542 23.375H16.459V25.167H14.375Z",
    fill: "#587E85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27 34L22 29L23.425 27.6L26 30.175V23H28V30.175L30.575 27.6L32 29L27 34Z",
    fill: "#A9CF3D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReduceIcon);
export default __webpack_public_path__ + "static/media/reduce-icon.180b5bd4c31c1a1b36bcdd9826906380.svg";
export { ForwardRef as ReactComponent };